import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=6e0b6f7a&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=6e0b6f7a&prod&lang=less"
import style1 from "./Personal.vue?vue&type=style&index=1&id=6e0b6f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b6f7a",
  null
  
)

export default component.exports